import * as type from './type';
export default {
    [type.SET_PRODUCT_LIST](state, productList) {
        state.productList = productList;
    },
    [type.SET_NO_MORE](state, noMore) {
        state.noMore = noMore;
    },
    [type.SET_KEYWORD](state, keyword) {
        state.keyword = keyword;
    },
    [type.SET_SEARCH_TYPE](state, searchType) {
        state.searchType = searchType;
    },
    [type.SET_SEARCH_SOURCE](state, searchSource) {
        state.searchSource = searchSource;
    },
    [type.SET_PAGE](state, page) {
        state.page = page;
    },
    [type.SET_PAGE_SIZE](state, pageSize) {
        state.pageSize = pageSize;
    },
    [type.SET_IS_REQUEST_SUCCESS](state, isRequestSuccess) {
        state.isRequestSuccess = isRequestSuccess;
    },
    [type.SET_IS_WOBBLE](state, isWobble) {
        state.isWobble = isWobble;
    },
    [type.SET_OLD_KEYWORD](state, oldKeyWord) {
        state.oldKeyWord = oldKeyWord;
    },
    [type.SET_RE_CORRECT](state, reCorrect) {
        state.reCorrect = reCorrect;
    },
    // 存储总页数，用于在返回顶部上方动态显示
    [type.SET_PAGE_COUNT](state, pageCount) {
        state.pageCount = pageCount
    },
}


// WEBPACK FOOTER //
// ./src/store/search-bar/mutations.js